import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'What is a loophole vaping companies found that allows them to legally promote their products?',
  inputType: 'radio',
  options: [
    {
      label: 'Paying Instagram for promoted posts.',
    },
    {
      label: 'Advertising e-cigarettes in magazines.',
    },
    {
      label: 'Paying influencers to use their product.',
    },
    {
      label: 'Advertising through TV commercials.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[2].label,
}

const feedback = {
  success: {
    title: 'Great job!',
    body: '',
  },
  error: {
    title: 'That’s incorrect.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 3',
  path: '/challenge/question-3',
  content: (
    <Fragment>
      <Intro
        title="Question 3"
        direction="Select the item that best completes the statement."
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question3.js